export default __webpack_public_path__ + "static/1-cba80b028b1559c997229da157358d88.png";